import { useQuery } from '@tanstack/react-query';
import { api, type ArcheDisplayMeta } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';
import { FEATURED_ARCHE_IDS } from '../data/featured-arches';

/**
 * Fetches real display metadata (name + icon) for the curated "Add Featured"
 * catalog arches, keyed by archId. The catalog itself is static; this only
 * resolves the live icon URL so cards render the real arche icon (with the
 * lucide fallback in the meantime). The id list is fixed, so a single
 * long-lived cache entry is enough.
 */
export function useFeaturedArcheMeta(): {
  metaById: Map<string, ArcheDisplayMeta>;
  isLoading: boolean;
} {
  const { data, isLoading } = useQuery({
    queryKey: queryKeys.favorites.featuredMeta(),
    queryFn: () => api.getArcheDisplayMeta(FEATURED_ARCHE_IDS),
    staleTime: 5 * 60 * 1000,
  });

  const metaById = new Map<string, ArcheDisplayMeta>(
    (data?.arches ?? []).map((a) => [a.archId, a]),
  );

  return { metaById, isLoading };
}
